/**
 * The Firebase client, as the data layer sees it.
 *
 * `src/firebase.js` initialises the app and exports the SDK handles; it stays
 * where it is because 117 files import it today. This module is the ONE path
 * into it from `src/data/`: an adapter imports `db` from here and the lint rule
 * in `eslint.web.cjs` refuses `firebase/*` and `src/firebase.js` anywhere else
 * under `data/`. When the old module is finally retired, the initialisation
 * moves here and nothing in `data/` changes.
 *
 * The handles are re-exported WITH their SDK types. `firebase.js` declares
 * `auth` with `let` and assigns it in a branch, so through `allowJs` its type
 * is `any` — and a named import of it is itself an implicit-any declaration
 * under `strict` (TS7034). Reading it off a namespace import sidesteps the
 * declaration, and the annotation here is what makes `strict` meaningful for
 * everything that imports from this module.
 *
 * Rules: `claude-docs/2026-10-21-ARCHITECTURE_ASSERTION.md`.
 */
import type { Auth } from 'firebase/auth';
import type { Firestore } from 'firebase/firestore';
import type { FirebaseStorage } from 'firebase/storage';
import type { Functions } from 'firebase/functions';
import * as legacy from '../../firebase';

export const auth: Auth = legacy.auth;
export const db: Firestore = legacy.db;
export const storage: FirebaseStorage = legacy.storage;
export const functions: Functions = legacy.functions;
